export { default } from './bcc-bank';
